import React, { useCallback, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import GettingStartedProgress from "app/components/GettingStarted/GettingStartedProgress";
import { cls } from "app/utils";
import { useActions, useSelector } from "app/utils/hooks";
import { createTag, clearTags } from "../../../actions/tag";
import { RootState } from "typedefs";
import { useTranslation } from "react-i18next";
import { shallowEqual } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

const AddTag = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { search } = useLocation();
  const tagAction = useActions({ createTag, clearTags });
  const [tagName, setTagName] = useState<null | string>(null);
  const [tagIsEmpty, setTagIsEmpty] = useState(false);

  const tagState = useSelector((state: RootState) => state.tag, shallowEqual);

  const tagHandler = (name: string) => {
    if (name && name.length) {
      setTagName(name);
      setTagIsEmpty(false);
    } else {
      setTagIsEmpty(true);
    }
  };

  const submitHandler = useCallback(() => {
    tagAction.clearTags();
    if (tagName && tagName.length > 0) {
      tagAction.createTag(tagName.trim()).then(() => {
        setTagIsEmpty(false);
        history.goBack();
      });
    } else {
      setTagIsEmpty(true);
    }
  }, [tagName, tagState]);

  useEffect(() => {
    if (!tagState.pending && tagState && tagState.error) {
      alert(tagState.error ? tagState.error : t("Something went wrong"));
    }
  }, [tagState]);

  return (
    <div className={styles.container}>
      <GettingStartedProgress />
      <div className={styles.add_tag_container}>
        <div className={styles.panel}>
          <h1>{t("Add Tag")}</h1>
        </div>
        <form className={styles.add_new_wrapper}>
          <span className={cls(styles.input_wrapper, "w-2-lg")}>
            <label htmlFor="tag">{t("Name")}</label>
            <input
              type="text"
              id="tag"
              name="tag"
              onChange={(e) => tagHandler(e.target.value)}
              className={cls({
                [styles.error]: tagIsEmpty,
              })}
            />
          </span>
          <span className={styles.buttons_container}>
            <button
              className="btn btn-primary"
              onClick={submitHandler}
              disabled={tagState.pending || tagIsEmpty}
              type="submit"
            >
              <span>
                {tagState.pending ? t("Please Wait...") : t("Create")}
              </span>
            </button>
            <button
              className={cls("btn btn-outline-secondary")}
              onClick={() => history.push(`/account/tags${search}`)}
              disabled={tagState.pending}
            >
              {t("Cancel")}
            </button>
          </span>
        </form>
      </div>
    </div>
  );
};

export default AddTag;
